<!-- content begin -->
<div id="content" class="no-bottom no-top">
  <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)"
    data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>About the post</h1>
          </div>
        </div>
      </div>

    </div>

  </section>
  <!-- section close -->



  <div class="row notifi_main ">
    <div class="col-md-12">
      <h2>
        Content Writer
      </h2>

      <p class="para_main_notify">
      </p>
    </div>
  </div>


  <!-- section begin -->
  <section id="section-services">
    <div class="container">

      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">





            <!-- feature box begin -->
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-graduation-cap"></i>
                <div class="text para_cls">
                  <h3>Qualification: </h3>
                  <p> <span class="step_no">1</span>Bachelor in Journalism & Mass Communication. A post-graduation in
                    relevant field is desirable qualification. </p>
                  <p> <span class="step_no">2</span>Should have good command over English (both written and verbal).</p>
                  <p> <span class="step_no">3</span>Proficient in handling computer and office related tools</p>
                  <p> <span class="step_no">4</span>Proficiency in English and Hindi language</p>




                </div>
              </div>
            </div>
            <!-- feature box close -->






            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-history"></i>
                <div class="text para_cls">
                  <h3>Experience:</h3>
                  <p> <span class="step_no">1</span>About 8 years of experience </p>
                  <p> <span class="step_no">2</span>The experience of working in the field of vocational training would
                    be given preference. </p>

                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-cogs"></i>
                <div class="text para_cls">
                  <h3>Skills and Competencies:</h3>
                  <p><span class="step_no">1</span> Writing and presentation skills </p>
                  <p><span class="step_no">2</span> Capability to convert the material received from the stakeholders
                    into a story-line. </p>
                  <p><span class="step_no">3</span> Ability to summarise technically complex information into plain
                    language communication product. </p>
                  <p><span class="step_no">4</span> Coordination capability for collection of content from officials of
                    DGT and State government.</p>
                  <p><span class="step_no">5</span> Time management to ensure timely and quality work to be published in
                    monthly newsletter editions consistently. </p>
                  <p><span class="step_no">6</span> Knowledge of latest technology driven tools for publishing
                    newsletters would be a preferred attribute for this position. </p>

                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-fa fa-globe"></i>
                <div class="text para_cls">
                  <h3>Scope of Work </h3>
                  <p> <span class="step_no">1</span> To bring out monthly newsletter-cum-magazine covering Skill
                    ecosystem in 3 States/UTs and 3 industrial sectors of the economy so as to cover all 36 States/UTs
                    and 40 sectors during a year </p>
                  <p> <span class="step_no">2</span> To bring out newsletter on monthly basis in a time bound manner.
                    • Coordination with DGT Hqrs, NSTIs, RDSDEs and State Directorates for retrieval of quality content
                    on good practices and success stories.
                  </p>
                  <p> <span class="step_no">3</span> To forward contents in a printable format to NIMI Chennai for
                    publishing. </p>
                  <p> <span class="step_no">4</span> To develop, write and disseminate media related items such as media
                    advisories and news releases, speeches and briefing notes for senior officers and management. </p>
                  <p> <span class="step_no">5</span> Any other related work as per requirement of the DGT </p>



                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-money"></i>
                <div class="text para_cls">
                  <h3>Period of Contract:</h3>
                  <p> <span class="step_no">1</span>The appointment to the post will be purely on contract basis
                    initially for a period of one year. The performance of the consultant will be reviewed after a year
                    and the contract shall be extended or discontinued (as the case may be) depending on the
                    performance. The decision of NIMI shall be final in this regard.</p>

                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-money"></i>
                <div class="text para_cls">
                  <h3>Remuneration:</h3>
                  <p> <span class="step_no">1</span> Rs. 50,000/- to Rs. 70,000/- per month (consolidated pay) depending
                    on the experience. The standard TDS will be deducted at source. Not entitled to any other allowance
                    or benefits. </p>

                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-calendar"></i>
                <div class="text para_cls">
                  <h3>Last Date:</h3>
                  <p style="color: red;"><b> Last date for Applying Online 15th August 2021 </b> </p>
                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-globe"></i>
                <div class="text para_cls">
                  <h3>Selection Process:</h3>
                  <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal
                    interview by a selection committee. Only shortlisted candidates will be called for the interview. No
                    TA/DA will be paid for attending the interview. At the time of interview, candidates shall produce
                    their original certificates for verification.</p>


                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-globe"></i>
                <div class="text para_cls">
                  <h3>Attendance and leave policy:</h3>
                  <p><span class="step_no">1</span>The working hours will be the same as for NIMI. No extra remuneration
                    shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays. </p>


                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-globe"></i>
                <div class="text para_cls">
                  <h3>Confidentiality and secrecy</h3>
                  <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any
                    information gathered during the period of engagement with the NIMI to any person who is not
                    authorised to know the same.</p>





                </div>
              </div>
            </div>
            <!-- feature box close -->





            <!-- <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
              <a href="https://nimiprojects.in/recruitment/register.php" target="_blank"
                class="btn-custom scroll-to">Apply Now</a>
            </div> -->


            <div class="container big_padd">








            </div>


          </div>
          <!-- content close -->




          <style>
            #section-intro {
              background-image: url(assets/images/background/niminew.jpg);
              background-size: cover;
              background-position: 0% 0px;
              height: 80vh !important;
            }

            .notifi_main {
              text-align: center;
              padding: 40px 0px;
            }

            .notifi_main h2 {
              border-bottom: 6px solid #F56B55;
              width: fit-content;
              margin: 0 auto;
              padding: 0px 30px;
            }

            .notifi_main .descrip_cls {
              padding: 5px 0px;
              font-weight: 500;
              font-size: 21px;
            }

            .overlay-bg.t50 {
              background: rgba(30, 30, 30, .1);
            }

            table {
              width: 100%;
              margin-top: 10px;
            }

            th,
            td {
              padding: 10px;
            }

            thead {
              background-color: #F56B55;
              color: #fff;
            }

            tr:nth-child(odd) {
              background-color: #eee;
            }

            .step_no {
              left: 80px;
              height: 30px;
              width: 30px;
              background-color: #F56B55;
              border-radius: 50%;
              display: inline-block;
              font-size: 18px;
              text-align: center;
              color: #fff;
              margin-right: 10px;
              position: absolute;
            }

            .para_cls p {
              padding-left: 35px;
            }

            .num_marks {
              text-align: center;
            }

            .last_tr {
              background-color: #F56B55 !important;
              color: #fff;
            }

            .notifi_main_table h2 {

              width: fit-content;
              margin: 0 auto;
              padding: 50px 30px 10px;
              font-size: 23px;

            }

            .para_main_notify {
              padding: 20px 0px;
              width: 50%;
              margin: 0 auto;
            }

            #section-services {
              padding: 0px !important;
            }
          </style>